// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3GGoo","head":"ProcedureTableInfo_head__2y4Dq"};